
import UsersByAccount from '../models/user.collection.js';

import { get as getPermissionDefs } from './permission-defs.js';

var allUsersSingleton;


const init = function(models) {
  allUsersSingleton = new UsersByAccount(null, { permissionDefs:getPermissionDefs() });
  allUsersSingleton.start(models);
};
  
const get = function() {
  return allUsersSingleton;
};

const getUserAttr = (user, attr)=> {
  const userModel = allUsersSingleton.getUserAttr(user, attr);
};


export { get, getUserAttr, init };
export default { get, getUserAttr, init };

